(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[5405],{

/***/ 48312:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/",
      function () {
        return __webpack_require__(11237);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 27320:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var html_react_parser__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(25935);
/* harmony import */ var utils_blogHelpers__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(63429);



const BlogCard = (param)=>{
    let { post , version , withImage =true  } = param;
    const { attributes  } = post;
    if (version === 2) {
        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
            className: "flex flex-wrap py-8",
            children: [
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                    className: "flex flex-col flex-shrink-0 mb-6 md:w-64 md:mb-0",
                    children: [
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                            className: "font-medium tracking-widest text-gray-900 title-font",
                            children: attributes.category
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                            className: "mt-1 text-sm text-gray-500",
                            children: attributes.date && (0,utils_blogHelpers__WEBPACK_IMPORTED_MODULE_2__/* .parseDate */ .s)(attributes.date).toISOString().split("T")[0]
                        })
                    ]
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                    className: "md:flex-grow",
                    children: [
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h2", {
                            className: "mb-2 text-2xl font-medium text-gray-900 title-font",
                            children: attributes.title
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                            className: "leading-relaxed",
                            children: attributes.description
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("a", {
                            className: "inline-flex items-center mt-4 text-san-juan-blue-500",
                            href: `/blog/${attributes.slug}`,
                            children: [
                                "Learn More",
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("svg", {
                                    className: "w-4 h-4 ml-2",
                                    viewBox: "0 0 24 24",
                                    stroke: "currentColor",
                                    strokeWidth: "2",
                                    fill: "none",
                                    strokeLinecap: "round",
                                    strokeLinejoin: "round",
                                    children: [
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                                            d: "M5 12h14"
                                        }),
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                                            d: "M12 5l7 7-7 7"
                                        })
                                    ]
                                })
                            ]
                        })
                    ]
                })
            ]
        });
    }
    if (version === 3) {
        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
            className: "flex flex-wrap py-8 md:flex-no-wrap",
            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                className: "relative h-full px-8 pt-16 pb-24 overflow-hidden text-center bg-gray-200 rounded-lg",
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h2", {
                        className: "mb-1 text-xs font-medium tracking-widest text-gray-500 title-font",
                        children: attributes.category
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h1", {
                        className: "mb-3 text-xl font-medium text-gray-900 title-font sm:text-2xl",
                        children: attributes.title
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                        className: "mb-3 leading-relaxed",
                        children: attributes.description
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("a", {
                        className: "inline-flex items-center text-san-juan-blue-500",
                        href: `/blog/${attributes.slug}`,
                        children: [
                            "Learn More",
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("svg", {
                                className: "w-4 h-4 ml-2",
                                viewBox: "0 0 24 24",
                                stroke: "currentColor",
                                strokeWidth: "2",
                                fill: "none",
                                strokeLinecap: "round",
                                strokeLinejoin: "round",
                                children: [
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                                        d: "M5 12h14"
                                    }),
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                                        d: "M12 5l7 7-7 7"
                                    })
                                ]
                            })
                        ]
                    })
                ]
            })
        });
    }
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
        className: "flex flex-col h-full overflow-hidden border border-gray-200 rounded-lg",
        children: [
            withImage && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("img", {
                className: "object-cover object-center w-full lg:h-48 md:h-36",
                src: attributes.image,
                alt: "blog",
                loading: "lazy"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                className: "p-6",
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("h2", {
                        className: "mb-1 text-xs font-medium tracking-widest text-gray-500 title-font",
                        children: [
                            attributes.category,
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                className: "mb-1 text-sm text-gray-500 float-right h-4",
                                children: attributes.date && (0,utils_blogHelpers__WEBPACK_IMPORTED_MODULE_2__/* .parseDate */ .s)(attributes.date).toISOString().split("T")[0]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h1", {
                        className: "mb-3 text-lg font-medium text-san-juan-blue-500 title-font",
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("a", {
                            className: "font-medium md:mb-2 lg:mb-0",
                            href: `/blog/${attributes.slug}`,
                            children: (0,html_react_parser__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .ZP)(attributes.title)
                        })
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                        className: "mb-3 leading-relaxed",
                        children: attributes.description
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                        className: "flex flex-wrap items-center ",
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("a", {
                            className: "inline-flex items-center font-medium text-san-juan-blue-500 md:mb-2 lg:mb-0",
                            href: `/blog/${attributes.slug}`,
                            children: [
                                "Read more",
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("svg", {
                                    className: "w-4 h-4 ml-2",
                                    viewBox: "0 0 24 24",
                                    stroke: "currentColor",
                                    strokeWidth: "2",
                                    fill: "none",
                                    strokeLinecap: "round",
                                    strokeLinejoin: "round",
                                    children: [
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                                            d: "M5 12h14"
                                        }),
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                                            d: "M12 5l7 7-7 7"
                                        })
                                    ]
                                })
                            ]
                        })
                    })
                ]
            })
        ]
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (BlogCard);


/***/ }),

/***/ 11237:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "__N_SSG": function() { return /* binding */ __N_SSG; },
  "default": function() { return /* binding */ pages; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./src/components/home/SEO.tsx
var SEO = __webpack_require__(56925);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/react-text-transition/lib-esm/index.js + 7 modules
var lib_esm = __webpack_require__(36265);
;// CONCATENATED MODULE: ./src/components/home/HeroSection/Hero1.tsx



const TEXTS = [
    "fast",
    "error-free",
    "resilient",
    "secure"
];
const Hero1 = ()=>{
    const [textIndex, setTextIndex] = (0,react.useState)(0);
    (0,react.useEffect)(()=>{
        const intervalId = setInterval(()=>setTextIndex((textIndex)=>textIndex < TEXTS.length - 1 ? textIndex + 1 : 0), 3000);
        return ()=>clearTimeout(intervalId);
    }, []);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("section", {
        className: "text-gray-700 body-font bg-gray-100",
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
            className: "container flex flex-col items-center px-5 pt-24 pb-5 mx-auto md:flex-row",
            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "flex flex-col items-center mb-16 text-center sm:text-left w-full xl:w-2/3 mx-auto",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("h1", {
                        className: "mb-4 text-3xl font-bold text-san-juan-blue-500 title-font sm:text-5xl",
                        children: [
                            "Ship fast web apps",
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
                            "that\xa0",
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: "inline-block text-summer-green-700",
                                children: [
                                    "stay\xa0",
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: "inline-block w-36 h-9 sm:w-60 sm:h-12 overflow-y-hidden align-bottom text-left",
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(lib_esm/* default */.Z, {
                                            className: "!inline-block",
                                            children: TEXTS[textIndex]
                                        })
                                    })
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                        className: "mb-8 sm:text-xl leading-relaxed max-w-xl",
                        children: "Use Latency Lingo to measure performance changes in your test environment and catch decline before your users do."
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "flex justify-center",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                href: "/signup",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                                    className: "px-8 py-4 text-lg font-medium text-san-juan-blue-500 bg-summer-green-400 shadow border border-summer-green-500 rounded focus:outline-none hover:bg-summer-green-500",
                                    children: "Try FREE now"
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                href: "https://docs.latencylingo.com/docs/intro",
                                target: "_blank",
                                rel: "noreferrer",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                                    className: "ml-4 px-8 py-4 text-lg font-medium text-summer-green-700 bg-summer-green-100 shadow border border-summer-green-300 rounded focus:outline-none hover:bg-summer-green-200",
                                    children: "Learn more"
                                })
                            })
                        ]
                    })
                ]
            })
        })
    });
};
/* harmony default export */ var HeroSection_Hero1 = (Hero1);

;// CONCATENATED MODULE: ./src/components/home/HeroSection/Hero2.tsx

const Hero2 = (param)=>{
    let { title , description , image  } = param;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("section", {
        className: "text-gray-700 body-font",
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: "container flex flex-col items-center px-5 py-24 mx-auto md:flex-row",
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "w-5/6 mb-10 lg:max-w-lg lg:w-full md:w-1/2 md:mb-0",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                        className: "object-cover object-center rounded",
                        alt: "hero",
                        src: image,
                        loading: "lazy"
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "flex flex-col items-center text-center lg:flex-grow md:w-1/2 lg:pl-24 md:pl-16 md:items-start md:text-left",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("h1", {
                            className: "mb-4 text-3xl font-bold text-gray-900 title-font sm:text-4xl",
                            children: title
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                            className: "mb-8 leading-relaxed",
                            children: description
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: "flex justify-center",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                                    className: "inline-flex px-6 py-2 text-lg text-white bg-indigo-500 border-0 rounded focus:outline-none hover:bg-indigo-600",
                                    children: "Button"
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                                    className: "inline-flex px-6 py-2 ml-4 text-lg text-gray-700 bg-gray-200 border-0 rounded focus:outline-none hover:bg-gray-300",
                                    children: "Button"
                                })
                            ]
                        })
                    ]
                })
            ]
        })
    });
};
/* harmony default export */ var HeroSection_Hero2 = (Hero2);

;// CONCATENATED MODULE: ./src/components/home/HeroSection/Hero3.tsx

const Hero3 = (param)=>{
    let { title , description , image  } = param;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("section", {
        className: "text-gray-700 body-font",
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: "container flex flex-col items-center justify-center px-5 py-24 mx-auto",
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                    className: "object-cover object-center w-5/6 mb-10 rounded lg:w-2/6 md:w-3/6",
                    alt: "hero",
                    src: image,
                    loading: "lazy"
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "w-full text-center lg:w-2/3",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("h1", {
                            className: "mb-4 text-3xl font-medium text-gray-900 title-font sm:text-4xl",
                            children: title
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                            className: "mb-8 leading-relaxed",
                            children: description
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: "flex justify-center",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                                    className: "inline-flex px-6 py-2 text-lg text-white bg-indigo-500 border-0 rounded focus:outline-none hover:bg-indigo-600",
                                    children: "Button"
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                                    className: "inline-flex px-6 py-2 ml-4 text-lg text-gray-700 bg-gray-200 border-0 rounded focus:outline-none hover:bg-gray-300",
                                    children: "Button"
                                })
                            ]
                        })
                    ]
                })
            ]
        })
    });
};
/* harmony default export */ var HeroSection_Hero3 = (Hero3);

;// CONCATENATED MODULE: ./src/components/home/HeroSection/index.tsx




const HeroSection = (param)=>{
    let { version , title , description , image  } = param;
    // List of different component versions. You can easily switch between versions from the CMS.
    const components = {
        1: HeroSection_Hero1,
        2: HeroSection_Hero2,
        3: HeroSection_Hero3
    };
    // Use the version prop to determine which component to render. Fallback to 1.
    const HeroComponent = components[version] || components[1];
    // Default return version 1 (with hero image on the right)
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(HeroComponent, {
        title: title,
        description: description,
        image: image
    });
};
/* harmony default export */ var home_HeroSection = (HeroSection);

// EXTERNAL MODULE: ./src/components/home/Layout.tsx
var Layout = __webpack_require__(90166);
// EXTERNAL MODULE: ./node_modules/react-icons/vsc/index.esm.js
var index_esm = __webpack_require__(14578);
// EXTERNAL MODULE: ./node_modules/react-icons/ai/index.esm.js
var ai_index_esm = __webpack_require__(8193);
// EXTERNAL MODULE: ./node_modules/html-react-parser/index.mjs
var html_react_parser = __webpack_require__(25935);
;// CONCATENATED MODULE: ./src/components/home/FeatureSection/Features1.tsx




const getIcon = function(i) {
    let size = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 5;
    switch(i){
        case 0:
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* VscDebugDisconnect */.ZUl, {
                className: `h-${size} w-${size}`
            });
        case 1:
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* VscRocket */.HhT, {
                className: `h-${size} w-${size}`
            });
        case 2:
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(ai_index_esm/* AiOutlineBarChart */.Io8, {
                className: `h-${size} w-${size}`
            });
    }
};
const Features1 = (param)=>{
    let { features  } = param;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: "flex flex-wrap -mx-4 -mt-4 -mb-10 sm:-m-4",
        children: features?.map((feature, i)=>{
            return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "flex flex-col items-center p-4 mb-6 text-center md:w-1/3 md:mb-0",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "inline-flex items-center justify-center flex-shrink-0 w-20 h-20 mb-5 font-medium text-summer-green-700 bg-summer-green-100 rounded-full",
                        children: getIcon(i, 8)
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "flex-grow",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("h2", {
                                className: "mb-3 text-lg font-medium text-san-juan-blue-500 title-font",
                                children: feature.name
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                className: "text-base text-left leading-relaxed mx-auto w-5/6",
                                children: (0,html_react_parser/* default */.ZP)(feature.description)
                            })
                        ]
                    })
                ]
            }, `feature-${i}`);
        })
    });
};
/* harmony default export */ var FeatureSection_Features1 = (Features1);

;// CONCATENATED MODULE: ./src/components/home/FeatureSection/Features2.tsx



const Features2_getIcon = function(i) {
    let size = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 5;
    switch(i){
        case 0:
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* VscRocket */.HhT, {
                className: `h-${size} w-${size}`
            });
        case 1:
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(ai_index_esm/* AiOutlineBarChart */.Io8, {
                className: `h-${size} w-${size}`
            });
        case 2:
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* VscDebugDisconnect */.ZUl, {
                className: `h-${size} w-${size}`
            });
    }
};
const Features2 = (param)=>{
    let { features  } = param;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: "flex flex-wrap -m-4",
        children: features?.map((feature, i)=>{
            return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "p-4 md:w-1/3",
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "flex flex-col h-full p-8 bg-gray-100 rounded-lg",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: "flex items-center mb-3",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: "inline-flex items-center justify-center flex-shrink-0 w-14 h-14 mr-3 text-san-juan-blue-500 bg-summer-green-400 rounded-full",
                                    children: Features2_getIcon(i, 8)
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("h2", {
                                    className: "text-lg font-medium text-san-juan-blue-600 title-font",
                                    children: feature.name
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: "flex-grow",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                    className: "text-base leading-relaxed",
                                    children: feature.description
                                }),
                                feature.learn_more && /*#__PURE__*/ (0,jsx_runtime.jsxs)("a", {
                                    className: "inline-flex items-center mt-3 text-summer-green-700",
                                    href: feature.learn_more,
                                    children: [
                                        "Learn More",
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("svg", {
                                            fill: "none",
                                            stroke: "currentColor",
                                            strokeLinecap: "round",
                                            strokeLinejoin: "round",
                                            strokeWidth: "2",
                                            className: "w-4 h-4 ml-2",
                                            viewBox: "0 0 24 24",
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                                d: "M5 12h14M12 5l7 7-7 7"
                                            })
                                        })
                                    ]
                                })
                            ]
                        })
                    ]
                })
            }, `feature-${i}`);
        })
    });
};
/* harmony default export */ var FeatureSection_Features2 = (Features2);

;// CONCATENATED MODULE: ./src/components/home/FeatureSection/Features3.tsx

const Features3 = (param)=>{
    let { features  } = param;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: "flex flex-wrap -m-4",
        children: features?.map((feature, i)=>{
            return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: `flex flex-col items-center pb-10 mx-auto mb-10 border-b border-gray-200 sm:flex-row ${i % 2 === 0 ? "sm:flex-row-reverse" : ""}`,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "inline-flex items-center justify-center flex-shrink-0 w-4/5 sm:w-1/3 border border-gray-300 sm:mx-5 rounded-lg",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                            src: feature.image,
                            alt: feature.name,
                            className: "rounded-lg"
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "flex-grow mt-6 text-center sm:text-left sm:mt-0 sm:mx-5",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("h2", {
                                className: "mb-2 text-lg font-medium text-san-juan-blue-500 title-font",
                                children: feature.name
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                className: "text-base leading-relaxed",
                                children: feature.description
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("a", {
                                className: "inline-flex items-center mt-3 text-summer-green-700",
                                href: feature.learn_more,
                                children: [
                                    "Learn More",
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("svg", {
                                        fill: "none",
                                        stroke: "currentColor",
                                        strokeLinecap: "round",
                                        strokeLinejoin: "round",
                                        strokeWidth: "2",
                                        className: "w-4 h-4 ml-2",
                                        viewBox: "0 0 24 24",
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                            d: "M5 12h14M12 5l7 7-7 7"
                                        })
                                    })
                                ]
                            })
                        ]
                    })
                ]
            }, `feature-${i}`);
        })
    });
};
/* harmony default export */ var FeatureSection_Features3 = (Features3);

;// CONCATENATED MODULE: ./src/components/home/FeatureSection/index.tsx





const FeatureSection = (param)=>{
    let { title , description , features , version  } = param;
    // List of different component versions. You can easily switch between versions from the CMS.
    const components = {
        1: FeatureSection_Features1,
        2: FeatureSection_Features2,
        3: FeatureSection_Features3
    };
    // Use the version prop to determine which component to render. Fallback to 1.
    const FeatureList = components[version] || components[1];
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("section", {
        className: "text-gray-700 body-font",
        id: "features",
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: "container px-5 py-16 mx-auto",
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "mb-16 text-center",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("h1", {
                            className: "mx-auto mb-8 text-xl font-bold text-san-juan-blue-500 sm:text-2xl lg:text-3xl title-font md:max-w-2xl",
                            children: (0,html_react_parser/* default */.ZP)(title)
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "mx-auto text-lg text-center sm:text-left leading-relaxed md:max-w-2xl",
                            children: (0,html_react_parser/* default */.ZP)(description)
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "flex justify-center mt-8",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "inline-flex w-16 h-1 bg-summer-green-500 rounded-full"
                            })
                        })
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(FeatureList, {
                    features: features
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "flex justify-center mt-16",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                            href: "/signup",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                                className: "px-8 py-4 text-lg font-medium text-san-juan-blue-500 bg-summer-green-400 shadow border border-summer-green-500 rounded focus:outline-none hover:bg-summer-green-500",
                                children: "Try FREE now"
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                            href: "https://docs.latencylingo.com/docs/intro",
                            target: "_blank",
                            rel: "noreferrer",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                                className: "ml-4 px-8 py-4 text-lg font-medium text-summer-green-700 bg-summer-green-100 shadow border border-summer-green-300 rounded focus:outline-none hover:bg-summer-green-200",
                                children: "Visit documentation"
                            })
                        })
                    ]
                })
            ]
        })
    });
};
/* harmony default export */ var home_FeatureSection = (FeatureSection);

// EXTERNAL MODULE: ./src/components/home/CtaSection/index.tsx
var CtaSection = __webpack_require__(38341);
// EXTERNAL MODULE: ./node_modules/next/link.js
var next_link = __webpack_require__(41664);
var link_default = /*#__PURE__*/__webpack_require__.n(next_link);
;// CONCATENATED MODULE: ./src/components/home/PricingSection/index.tsx



const PricingSection = (param)=>{
    let { title , description , plans  } = param;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("section", {
        className: "text-gray-700 body-font",
        id: "pricing",
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: "px-5 py-24 mx-auto md:max-w-5xl lg:max-w-6xl",
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "mb-20 text-center",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("h1", {
                            className: "mb-4 text-2xl font-bold text-san-juan-blue-500 lg:text-4xl sm:text-3xl title-font",
                            children: title
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                            className: "mx-auto text-base leading-relaxed max-w-md",
                            children: (0,html_react_parser/* default */.ZP)(description)
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "flex justify-center mt-6",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "inline-flex w-16 h-1 bg-summer-green-500 rounded-full"
                            })
                        })
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "flex flex-wrap -mx-4 -mt-4 -mb-10 sm:-m-4",
                    children: plans?.map((plan, i)=>{
                        return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "w-full p-4 md:w-1/2",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: "relative flex flex-col h-full p-6 overflow-hidden border-2 border-gray-300 rounded-lg",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("h2", {
                                        className: "mb-1 text-sm font-medium tracking-widest title-font",
                                        children: plan.name
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("h1", {
                                        className: "flex items-center pb-4 mb-4 text-5xl leading-none text-gray-900 border-b border-gray-200",
                                        children: plan.price === "Free" ? /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                            children: "FREE"
                                        }) : /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                    children: plan.price
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                    className: "ml-1 text-lg font-normal text-gray-500",
                                                    children: "/mo"
                                                })
                                            ]
                                        })
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: "my-2",
                                        children: plan.usps?.map((usp, i)=>{
                                            return /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                                                className: "flex items-center mb-2 text-gray-600",
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                        className: "inline-flex items-center justify-center flex-shrink-0 w-4 h-4 mr-2 text-white bg-summer-green-500 rounded-full",
                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("svg", {
                                                            fill: "none",
                                                            stroke: "currentColor",
                                                            strokeLinecap: "round",
                                                            strokeLinejoin: "round",
                                                            strokeWidth: "2.5",
                                                            className: "w-3 h-3",
                                                            viewBox: "0 0 24 24",
                                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                                                d: "M20 6L9 17l-5-5"
                                                            })
                                                        })
                                                    }),
                                                    usp
                                                ]
                                            }, i);
                                        })
                                    }),
                                    plan.wip === true ? /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                        href: "mailto:support@latencylingo.com",
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("button", {
                                            className: "flex items-center text-left w-full px-4 py-2 mt-auto text-san-juan-blue-500 bg-summer-green-400 border border-summer-green-500 rounded focus:outline-none hover:bg-summer-green-500",
                                            children: [
                                                "Reach out to access our closed beta!",
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("svg", {
                                                    fill: "none",
                                                    stroke: "currentColor",
                                                    strokeLinecap: "round",
                                                    strokeLinejoin: "round",
                                                    strokeWidth: "2",
                                                    className: "w-4 h-4 ml-auto",
                                                    viewBox: "0 0 24 24",
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                                        d: "M5 12h14M12 5l7 7-7 7"
                                                    })
                                                })
                                            ]
                                        })
                                    }) : /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                        href: "/signup",
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("button", {
                                            className: "flex items-center text-left w-full px-4 py-2 mt-auto font-medium text-san-juan-blue-500 bg-summer-green-400 border border-summer-green-500 hover:bg-summer-green-500 rounded focus:outline-none",
                                            children: [
                                                plan.price === "Free" ? "Get started" : "Start a free trial",
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("svg", {
                                                    fill: "none",
                                                    stroke: "currentColor",
                                                    strokeLinecap: "round",
                                                    strokeLinejoin: "round",
                                                    strokeWidth: "2",
                                                    className: "w-4 h-4 ml-auto",
                                                    viewBox: "0 0 24 24",
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                                        d: "M5 12h14M12 5l7 7-7 7"
                                                    })
                                                })
                                            ]
                                        })
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                        className: "mt-3 text-xs text-gray-500",
                                        children: plan.description
                                    })
                                ]
                            })
                        }, i);
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "mt-16",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "text-center text-lg mb-4",
                            children: "Have any questions or need higher limits?"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "flex",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                href: "mailto:support@latencylingo.com",
                                className: "mx-auto",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                                    className: "px-8 py-4 text-lg font-medium text-summer-green-700 bg-summer-green-100 border border-summer-green-200 hover:bg-summer-green-200 rounded focus:outline-none",
                                    children: "Let's talk!"
                                })
                            })
                        })
                    ]
                })
            ]
        })
    });
};
/* harmony default export */ var home_PricingSection = (PricingSection);

;// CONCATENATED MODULE: ./src/utils/getIcon.tsx
// returns a different icon based on the given index for demo purposes

const getIcon_getIcon = function(i) {
    let size = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 5;
    switch(i){
        case 0:
            return /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
                fill: "none",
                stroke: "currentColor",
                strokeLinecap: "round",
                strokeLinejoin: "round",
                strokeWidth: "2",
                className: `w-${size} h-${size}`,
                viewBox: "0 0 24 24",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("circle", {
                        cx: "12",
                        cy: "5",
                        r: "3"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        d: "M12 22V8M5 12H2a10 10 0 0020 0h-3"
                    })
                ]
            });
        case 1:
            return /*#__PURE__*/ (0,jsx_runtime.jsx)("svg", {
                fill: "none",
                stroke: "currentColor",
                strokeLinecap: "round",
                strokeLinejoin: "round",
                strokeWidth: "2",
                className: `w-${size} h-${size}`,
                viewBox: "0 0 24 24",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                    d: "M22 12h-4l-3 9L9 3l-3 9H2"
                })
            });
        case 2:
            return /*#__PURE__*/ (0,jsx_runtime.jsx)("svg", {
                fill: "none",
                stroke: "currentColor",
                strokeLinecap: "round",
                strokeLinejoin: "round",
                strokeWidth: "2",
                className: `w-${size} h-${size}`,
                viewBox: "0 0 24 24",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                    d: "M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z"
                })
            });
        case 3:
            return /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
                fill: "none",
                stroke: "currentColor",
                strokeLinecap: "round",
                strokeLinejoin: "round",
                strokeWidth: "2",
                className: `w-${size} h-${size}`,
                viewBox: "0 0 24 24",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        d: "M22 11.08V12a10 10 0 11-5.93-9.14"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        d: "M22 4L12 14.01l-3-3"
                    })
                ]
            });
        default:
            return /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
                fill: "none",
                stroke: "currentColor",
                strokeLinecap: "round",
                strokeLinejoin: "round",
                strokeWidth: "2",
                className: `w-${size} h-${size}`,
                viewBox: "0 0 24 24",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        d: "M20 21v-2a4 4 0 00-4-4H8a4 4 0 00-4 4v2"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("circle", {
                        cx: "12",
                        cy: "7",
                        r: "4"
                    })
                ]
            });
    }
};

;// CONCATENATED MODULE: ./src/components/home/StepsSection/Steps1.tsx


const Steps1 = (param)=>{
    let { image , steps  } = param;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("section", {
        className: "text-gray-700 body-font",
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
            className: "container flex flex-wrap px-5 py-24 mx-auto",
            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "flex flex-wrap w-full",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "lg:w-2/5 md:w-1/2 md:pr-10 md:py-6",
                        children: steps?.map((step, i)=>{
                            return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: "relative flex pb-12",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: "absolute inset-0 flex items-center justify-center w-10 h-full",
                                        children: i !== steps.length - 1 && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            className: "w-1 h-full bg-gray-200 pointer-events-none"
                                        })
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: "relative z-10 inline-flex items-center justify-center flex-shrink-0 w-10 h-10 text-white bg-indigo-500 rounded-full",
                                        children: getIcon_getIcon(i)
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                        className: "flex-grow pl-4",
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("h2", {
                                                className: "mb-1 text-sm font-bold tracking-wider text-gray-900 title-font",
                                                children: step.name
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                className: "leading-relaxed",
                                                children: step.description
                                            })
                                        ]
                                    })
                                ]
                            }, `step-${i}`);
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                        className: "object-cover object-center mt-12 rounded-lg lg:w-3/5 md:w-1/2 md:mt-0",
                        src: image,
                        alt: "step",
                        loading: "lazy"
                    })
                ]
            })
        })
    });
};
/* harmony default export */ var StepsSection_Steps1 = (Steps1);

;// CONCATENATED MODULE: ./src/components/home/StepsSection/Steps2.tsx


const Steps2 = (param)=>{
    let { steps  } = param;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("section", {
        className: "text-san-juan-blue-500 body-font",
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
            className: "container flex flex-wrap px-5 mx-auto",
            children: steps?.map((step, i)=>{
                return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "relative flex pt-10 pb-20 mx-auto sm:items-center md:w-2/3",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "absolute inset-0 flex items-center justify-center w-10 h-full",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "w-1 h-full bg-gray-200 pointer-events-none"
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "relative z-10 inline-flex items-center justify-center flex-shrink-0 w-10 h-10 mt-10 text-base font-medium text-san-juan-blue-500 bg-summer-green-400 rounded-full sm:mt-0 title-font",
                            children: i + 1
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "flex flex-col items-start flex-grow pl-6 md:pl-8 sm:items-center sm:flex-row",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: "flex-grow mt-6 sm:pl-6 sm:mt-0",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("h2", {
                                        className: "mb-1 text-xl font-medium text-gray-900 title-font",
                                        children: step.name
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                        className: "leading-relaxed text-lg",
                                        children: (0,html_react_parser/* default */.ZP)(step.description)
                                    }),
                                    step.learn_more && /*#__PURE__*/ (0,jsx_runtime.jsxs)("a", {
                                        className: "inline-flex items-center mt-3 text-summer-green-700",
                                        href: step.learn_more,
                                        children: [
                                            "Learn More",
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("svg", {
                                                fill: "none",
                                                stroke: "currentColor",
                                                strokeLinecap: "round",
                                                strokeLinejoin: "round",
                                                strokeWidth: "2",
                                                className: "w-4 h-4 ml-2",
                                                viewBox: "0 0 24 24",
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                                    d: "M5 12h14M12 5l7 7-7 7"
                                                })
                                            })
                                        ]
                                    })
                                ]
                            })
                        })
                    ]
                }, `step-${i}`);
            })
        })
    });
};
/* harmony default export */ var StepsSection_Steps2 = (Steps2);

;// CONCATENATED MODULE: ./src/components/home/StepsSection/Steps3.tsx


const Steps3 = (param)=>{
    let { image , steps  } = param;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("section", {
        className: "text-gray-700 body-font",
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: "container flex flex-col flex-wrap px-5 py-24 mx-auto",
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "flex flex-wrap mx-auto mb-20",
                    children: steps?.map((_, i)=>{
                        return /*#__PURE__*/ (0,jsx_runtime.jsxs)("a", {
                            className: `inline-flex items-center justify-center w-1/2 py-3 font-medium leading-none tracking-wider border-b-2  rounded-t sm:px-6 sm:w-auto sm:justify-start title-font ${i > 0 ? "border-gray-200 hover:text-gray-900" : "text-indigo-500 bg-gray-100 border-indigo-500"}`,
                            children: [
                                getIcon_getIcon(i, 5),
                                " ",
                                `STEP ${i + 1}`
                            ]
                        }, `step-${i}`);
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                    className: "block object-cover object-center w-2/3 mx-auto mb-10 rounded xl:w-1/4 lg:w-1/3 md:w-1/2",
                    src: image,
                    alt: "step",
                    loading: "lazy"
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "flex flex-col w-full text-center",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("h1", {
                            className: "mb-4 text-xl font-medium text-gray-900 title-font",
                            children: steps[0].name
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                            className: "mx-auto text-base leading-relaxed lg:w-2/3",
                            children: steps[0].description
                        })
                    ]
                })
            ]
        })
    });
};
/* harmony default export */ var StepsSection_Steps3 = (Steps3);

;// CONCATENATED MODULE: ./src/components/home/StepsSection/index.tsx




const StepsSection = (param)=>{
    let { version , steps , image  } = param;
    // List of different component versions. You can easily switch between versions from the CMS.
    const components = {
        1: StepsSection_Steps1,
        2: StepsSection_Steps2,
        3: StepsSection_Steps3
    };
    // Use the version prop to determine which component to render. Fallback to 1.
    const StepsComponent = components[version] || components[1];
    // Default return version 1, with hero image on the right
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "text-center",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("h1", {
                        className: "my-4 text-2xl font-bold text-san-juan-blue-500 sm:text-3xl lg:text-4xl title-font",
                        children: "How does it work?"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "flex justify-center mt-6 mb-12",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "inline-flex w-16 h-1 bg-summer-green-500 rounded-full"
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(StepsComponent, {
                steps: steps,
                image: image
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "flex mt-16",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                    href: "https://docs.latencylingo.com/docs/intro",
                    target: "_blank",
                    rel: "noreferrer",
                    className: "mx-auto",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                        className: "px-8 py-4 text-lg font-medium text-summer-green-700 bg-summer-green-100 border border-summer-green-200 hover:bg-summer-green-200 rounded focus:outline-none",
                        children: "Read more in our documentation"
                    })
                })
            })
        ]
    });
};
/* harmony default export */ var home_StepsSection = (StepsSection);

// EXTERNAL MODULE: ./src/components/home/BlogCard.tsx
var BlogCard = __webpack_require__(27320);
;// CONCATENATED MODULE: ./src/components/home/BlogSection/Posts1.tsx


const Posts1 = (param)=>{
    let { posts  } = param;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: "grid max-w-lg gap-5 mx-auto mt-12 md:grid-cols-2 lg:grid-cols-3 md:max-w-none",
        children: posts?.map((post, i)=>{
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(BlogCard/* default */.Z, {
                version: 1,
                withImage: false,
                post: post
            }, i);
        })
    });
};
/* harmony default export */ var BlogSection_Posts1 = (Posts1);

;// CONCATENATED MODULE: ./src/components/home/BlogSection/Posts2.tsx

const Posts2 = (param)=>{
    let { posts  } = param;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: "flex flex-wrap mt-4",
        children: posts?.map((post, i)=>{
            return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "flex flex-wrap py-8 md:flex-no-wrap",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "flex flex-col flex-shrink-0 mb-6 md:w-64 md:mb-0",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                className: "font-medium tracking-widest text-gray-900 title-font",
                                children: post.attributes.category
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                className: "mt-1 text-sm text-gray-500",
                                children: post.attributes.date && new Date(post.attributes.date).toLocaleDateString().split("T")[0]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "md:flex-grow",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("h2", {
                                className: "mb-2 text-2xl font-medium text-gray-900 title-font",
                                children: post.attributes.title
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                className: "leading-relaxed",
                                children: post.attributes.description
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("a", {
                                className: "inline-flex items-center mt-4 text-indigo-500",
                                href: `/blog/${post.attributes.slug}`,
                                children: [
                                    "Learn More",
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
                                        className: "w-4 h-4 ml-2",
                                        viewBox: "0 0 24 24",
                                        stroke: "currentColor",
                                        strokeWidth: "2",
                                        fill: "none",
                                        strokeLinecap: "round",
                                        strokeLinejoin: "round",
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                                d: "M5 12h14"
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                                d: "M12 5l7 7-7 7"
                                            })
                                        ]
                                    })
                                ]
                            })
                        ]
                    })
                ]
            }, `post-${i}`);
        })
    });
};
/* harmony default export */ var BlogSection_Posts2 = (Posts2);

;// CONCATENATED MODULE: ./src/components/home/BlogSection/Posts3.tsx

const Posts3 = (param)=>{
    let { posts  } = param;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: "flex flex-wrap mt-4 -m-4",
        children: posts?.map((post, i)=>{
            return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "p-4 md:w-1/3",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "flex flex-wrap py-8 md:flex-no-wrap",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "relative h-full px-8 pt-16 pb-24 overflow-hidden text-center bg-gray-200 rounded-lg",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("h2", {
                                className: "mb-1 text-xs font-medium tracking-widest text-gray-500 title-font",
                                children: post.attributes.category
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("h1", {
                                className: "mb-3 text-xl font-medium text-gray-900 title-font sm:text-2xl",
                                children: post.attributes.title
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                className: "mb-3 leading-relaxed",
                                children: post.attributes.description
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("a", {
                                className: "inline-flex items-center text-indigo-500",
                                href: `/blog/${post.attributes.slug}`,
                                children: [
                                    "Learn More",
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
                                        className: "w-4 h-4 ml-2",
                                        viewBox: "0 0 24 24",
                                        stroke: "currentColor",
                                        strokeWidth: "2",
                                        fill: "none",
                                        strokeLinecap: "round",
                                        strokeLinejoin: "round",
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                                d: "M5 12h14"
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                                d: "M12 5l7 7-7 7"
                                            })
                                        ]
                                    })
                                ]
                            })
                        ]
                    })
                })
            }, `post-${i}`);
        })
    });
};
/* harmony default export */ var BlogSection_Posts3 = (Posts3);

;// CONCATENATED MODULE: ./src/components/home/BlogSection/index.tsx





const BlogSection = (param)=>{
    let { title , description , slugs , version  } = param;
    const [posts, setPosts] = (0,react.useState)([]);
    (0,react.useEffect)(()=>{
        const getPosts = async ()=>{
            const postsPromises = await slugs.map(async (slug)=>{
                return __webpack_require__(20691)(`./${slug}.mdx`);
            });
            Promise.all(postsPromises).then(setPosts);
        };
        getPosts();
    }, [
        slugs
    ]);
    // List of different component versions. You can easily switch between versions from the CMS.
    const components = {
        1: BlogSection_Posts1,
        2: BlogSection_Posts2,
        3: BlogSection_Posts3
    };
    // Use the version prop to determine which component to render. Fallback to 1.
    const BlogPostList = components[version] || components[1];
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("section", {
        className: "text-gray-700 body-font",
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: "container px-5 py-16 mx-auto",
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "w-full mb-20 text-center",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("h1", {
                            className: "mb-4 text-2xl font-bold text-san-juan-blue-500 sm:text-3xl lg:text-4xl title-font",
                            children: title
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                            className: "mx-auto text-base leading-relaxed lg:w-2/3",
                            children: description
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "flex justify-center mt-6",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "inline-flex w-16 h-1 bg-summer-green-500 rounded-full"
                            })
                        })
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(BlogPostList, {
                    posts: posts
                })
            ]
        })
    });
};
/* harmony default export */ var home_BlogSection = (BlogSection);

;// CONCATENATED MODULE: ./src/components/home/ExplainSection/index.tsx


const ExplainSection = (param)=>{
    let { title , description  } = param;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("section", {
        className: "text-gray-700 body-font",
        id: "explain",
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
            className: "container px-5 pb-8 mx-auto",
            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "mb-16 text-center",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("h1", {
                        className: "mx-auto text-xl font-bold text-san-juan-blue-500 sm:text-2xl lg:text-3xl title-font md:max-w-2xl",
                        children: (0,html_react_parser/* default */.ZP)(title)
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "flex justify-center my-8",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "inline-flex w-16 h-1 bg-summer-green-500 rounded-full"
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "mx-auto text-lg text-center sm:text-left leading-relaxed md:max-w-2xl",
                        children: (0,html_react_parser/* default */.ZP)(description)
                    })
                ]
            })
        })
    });
};
/* harmony default export */ var home_ExplainSection = (ExplainSection);

;// CONCATENATED MODULE: ./src/components/home/LogoSection/index.tsx

const Logo = (param)=>{
    let { src  } = param;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: "mt-2 w-44 mx-auto",
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
            src: src,
            alt: src
        })
    });
};
const LogoSection = ()=>{
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("section", {
        className: "text-gray-700 body-font",
        id: "logos",
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: "container pt-20 px-5 mx-auto",
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "mb-16 text-center",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("h1", {
                            className: "mx-auto text-xl font-bold text-san-juan-blue-500 sm:text-2xl lg:text-3xl title-font md:max-w-2xl",
                            children: "Join the best performance testers"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "flex justify-center my-8",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "inline-flex w-16 h-1 bg-summer-green-500 rounded-full"
                            })
                        })
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "sm:flex justify-between items-center",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Logo, {
                            src: "img/dxc_logo.png"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Logo, {
                            src: "img/cognizant_logo.png"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Logo, {
                            src: "img/colan_logo.png"
                        })
                    ]
                })
            ]
        })
    });
};
/* harmony default export */ var home_LogoSection = (LogoSection);

;// CONCATENATED MODULE: ./src/pages/index.tsx











const HomePage = (param)=>{
    let { content  } = param;
    const { attributes  } = content;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(SEO/* default */.Z, {}),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Layout/* default */.Z, {
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(home_HeroSection, {
                            version: attributes.hero_version,
                            title: attributes.hero_title,
                            description: attributes.hero_description,
                            image: attributes.hero_image
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(home_FeatureSection, {
                            version: attributes.feature_version,
                            title: attributes.feature_title,
                            description: attributes.feature_description,
                            features: attributes.features
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(home_StepsSection, {
                            version: attributes.steps_version,
                            steps: attributes.steps,
                            image: attributes.steps_image
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(home_LogoSection, {}),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(home_PricingSection, {
                            title: attributes.pricing_title,
                            description: attributes.pricing_description,
                            plans: attributes.plans
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(home_ExplainSection, {
                            title: attributes.explain_title,
                            description: attributes.explain_description
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(CtaSection/* default */.Z, {}),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(home_BlogSection, {
                            version: attributes.blog_version,
                            title: attributes.blog_title,
                            description: attributes.blog_description,
                            slugs: attributes.posts
                        })
                    ]
                })
            })
        ]
    });
};
var __N_SSG = true;
/* harmony default export */ var pages = (HomePage);


/***/ }),

/***/ 63429:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "s": function() { return /* binding */ parseDate; }
/* harmony export */ });
/* harmony import */ var dayjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(27484);
/* harmony import */ var dayjs__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(dayjs__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var dayjs_plugin_customParseFormat__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(10285);
/* harmony import */ var dayjs_plugin_customParseFormat__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(dayjs_plugin_customParseFormat__WEBPACK_IMPORTED_MODULE_1__);


dayjs__WEBPACK_IMPORTED_MODULE_0___default().extend((dayjs_plugin_customParseFormat__WEBPACK_IMPORTED_MODULE_1___default()));
const parseDate = (date)=>{
    return dayjs__WEBPACK_IMPORTED_MODULE_0___default()(date, "YYYY-MM-DDThh:mm:ss.SSSZ").toDate();
};


/***/ }),

/***/ 20691:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var map = {
	"./added-support-for-gatling.mdx": [
		59149,
		9149
	],
	"./automate-performance-testing-with-jmeter.mdx": [
		14682,
		4682
	],
	"./black-friday-performance-analysis.mdx": [
		96749,
		6749
	],
	"./github-actions-integration.mdx": [
		78916,
		8916
	],
	"./introducing-performance-test-thresholds.mdx": [
		80130,
		130
	],
	"./performance-test-metrics-reporting.mdx": [
		20185,
		185
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return __webpack_require__.e(ids[1]).then(function() {
		return __webpack_require__.t(id, 7 | 16);
	});
}
webpackAsyncContext.keys = function() { return Object.keys(map); };
webpackAsyncContext.id = 20691;
module.exports = webpackAsyncContext;

/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [3874,1228,8907,2876,4617,1664,8274,1344,1849,9232,9774,2888,179], function() { return __webpack_exec__(48312); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);